import {AfterViewInit, Component, Inject, OnInit, ViewChild} from '@angular/core';
import {FormControl, FormGroup} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef, MatSort, MatTableDataSource, Sort} from "@angular/material";
import {MessageService} from "../../../core/services/message.service";
import {Plano} from "../../../models/plano";
import {Usuario} from "../../../models/usuario";
import {UsuarioService} from "../../../services/usuario.service";
import {NgxSpinnerService} from "ngx-spinner";
import {Perfil} from "../../../models/perfil";
import {PlanoService} from "../../../services/plano.service";

@Component({
	selector: 'app-dialog-plano-gestor',
	templateUrl: './dialog-plano-gestor.component.html',
	styleUrls: ['./dialog-plano-gestor.component.scss']
})
export class DialogPlanoGestorComponent implements OnInit, AfterViewInit {

	public form: FormGroup;
	public plano: Plano;
	public usuarios: Array<Usuario>;
	public data_source: MatTableDataSource<any>;
	public pesquisa_realizada: boolean = false;

	@ViewChild(MatSort) sort: MatSort;

	constructor(public dialogRef: MatDialogRef<DialogPlanoGestorComponent>, @Inject(MAT_DIALOG_DATA) public data:any, private messageService: MessageService, private loadingService: NgxSpinnerService, private usuarioService: UsuarioService, private planoService: PlanoService) {

	}

	ngOnInit() {
		this.data_source = new MatTableDataSource(this.usuarios);
		this.dialogRef.disableClose = true;
		this.plano = this.data.plano as Plano;
		this.form = new FormGroup({
			nome: new FormControl(),
			cpf: new FormControl(),
			email: new FormControl(),
		});
	}

	ngAfterViewInit(): void{
		this.data_source.sort = this.sort;
		this.data_source.sortingDataAccessor = (data, header) => data[header];
	}

	sortData(sort: Sort): void{
		const data = this.data_source.data.slice();
		if(!sort.active || sort.direction === ''){
			this.data_source.data = data;
		}
		this.data_source.data = data.sort((a, b) => {
			const is_asc = sort.direction === 'asc';
			switch(sort.active){
				case 'nome': return this.compare(a.txt_nome, b.txt_nome, is_asc);
				case 'cpf': return this.compare(a.num_cpf, b.num_cpf, is_asc);
				case 'email': return this.compare(a.txt_email, b.txt_email, is_asc);
				default: return 0;
			}
		});
	}

	compare(a: number | string, b: number | string, is_asc: boolean): number{
		return (a < b ? -1 : 1) * (is_asc ? 1 : -1);
	}

	carregarUsuarios(nome: string = null, cpf: string = null, email: string = null){
		this.pesquisa_realizada = false;
		this.usuarios = [];
		this.data_source.data = this.usuarios;
		if(nome || cpf || email){
			this.loadingService.show();
			this.usuarioService.listAll(Perfil.GESTOR, nome, cpf, email).subscribe((usuarios: Array<Usuario>) => {
				this.usuarios = usuarios;
				this.data_source.data = this.usuarios;
				this.pesquisa_realizada = true;
				this.loadingService.hide();
			}, (error: any) => {
				this.loadingService.hide();
				this.messageService.showResponseError(error);
				this.pesquisa_realizada = true;
			});
		}else{
			this.messageService.showError("Informe um filtro para realizar a busca");
		}
	}

	save(cod_usuario: number): void{
		if(cod_usuario && this.plano.cod_plano){
			this.loadingService.show();
			this.plano.cod_usuario = cod_usuario;
			this.planoService.updateUsuario(this.plano.cod_plano, this.plano.cod_usuario).subscribe((data: any) => {
				this.loadingService.hide();
				this.messageService.showSuccess(data.message);
				this.dialogRef.close();
			}, (error: any) => {
				this.loadingService.hide();
				this.messageService.showResponseError(error);
			});
		}
	}

}
